import axios from '../../axios-auth'
import globalAxios from 'axios'
import router from '../../router/routes'

export const actions = {
  setLogoutTimer({ commit }, expirationTime) {
    setTimeout(() => {
      commit('REMOVE_AUTH')
    }, expirationTime * 1000)
  },
  login({ commit, dispatch }, authData) {
    commit('SET_REQUEST_COMPLETE', false)

    axios.post('/auth/login', {
      username: authData.username,
      password: authData.password
    })
      .then(res => {
        const now = new Date()
        const expirationDate = new Date(now.getTime() + res.data.expires_in * 1000)
        localStorage.setItem('token', res.data.access_token)
        localStorage.setItem('userName', res.data.username)
        localStorage.setItem('expirationDate', expirationDate)
        commit('SET_AUTH', {
          token: res.data.access_token,
          userName: res.data.username
        })
        dispatch('setLogoutTimer', res.data.expires_in)
        dispatch('fetchUserInfo').then(() => {
          commit('SET_REQUEST_COMPLETE', true)
          router.push('/')
        })
      })
      .catch(error => {
        commit('SET_REQUEST_COMPLETE', true)
        console.log(error)
      })
  },
  initLoginToStore({ commit }) {
    const token = localStorage.getItem('token')
    if (!token) {
      return
    }

    const expirationDate = new Date(localStorage.getItem('expirationDate'))
    const now = new Date()
    if (now >= expirationDate) {
      return
    }

    const userName = localStorage.getItem('userName')
    commit('SET_AUTH', {
      token: token,
      userName: userName
    })
  },
  logout({ commit }) {
    commit('REMOVE_AUTH')
    localStorage.removeItem('expirationDate')
    localStorage.removeItem('token')
    localStorage.removeItem('userName')
    router.replace('/login')
  },
  fetchUserInfo({ commit }) {
    return globalAxios.get('/user')
      .then(res => {
        res.data.currency.forEach((currency) => {
          if (currency.type === 1) { // type:1 = yipps wallet
            commit('SET_CURRENCY', currency.sum)
          }
        })
        if (res.data.avatar) { commit('SET_USER_AVATAR', res.data.avatar.url) }
      })
      .catch(error => {
        console.log(error)
      })
  }
}
